import React, { Component } from 'react'
import { Panel, Container, Button, List } from '@sencha/ext-modern'
import { compose } from 'redux'
import { connect } from 'react-redux'
import escapeRegExp from 'escape-string-regexp'

import AppTitle from './AppTitle'
import { doGetAllTaskList, doSubmitTask } from '../../reducers/actions'

Ext.require([
  'Ext.dataview.listswiper.ListSwiper'
])

class MyTask extends Component {
  state = {
    query: '',
    showSearchForPhone: false,
    loading: false,
    errorMessage: null,
    selectedTaskType: '全部',
  }

  componentDidMount() {
    const { doGetAllTaskList } = this.props
    doGetAllTaskList({
      onRequest: () => {
        this.setState({ loading: true })
      },
      onEnd: ({ errorMessage, allTaskList }) => {
        errorMessage && this.setState({ loading: false, errorMessage }) ||
          this.setState({ loading: false, allTaskList })
      }
    })
  }

  search = (field, value) => {
    this.setState({ query: value })
  }

  handleSearchClick = () => {
    const { showSearchForPhone } = this.state
    this.setState({ showSearchForPhone: !showSearchForPhone })
  }

  handleSelectType = (e) => {
    this.setState({ selectedTaskType: e._text })
  }

  tasks = ({ selectedTaskList }) => {
    const { doSubmitTask, doGetAllTaskList } = this.props
    const { query } = this.state
    let showTaskList
    if (query) {
      const match = new RegExp(escapeRegExp(query), 'i')
      showTaskList = selectedTaskList.filter(item => match.test(item.number) || match.test(item.title) || match.test(item.name))
    } else {
      showTaskList = selectedTaskList
    }
    return (
      <List
        shadow
        itemTpl={data => (
          <div>
            <div style={{ fontSize: '16px', marginBottom: '5px' }}>{data.number} {data.name}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>【{data.title}】 提交日期：{data.date}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>{data.content}</div>
          </div>
        )}
        store={showTaskList}
        onChildTap={(list, info) => {
          const task = info.record.data
          console.log('task', task)
          location.hash = `QYWX/DetailTask/${task.title}/${task.type}/${task.id}`
        }}
        plugins={[{
          type: 'listswiper',
          defaults: {
            ui: 'action'
          },
          right: [{
            iconCls: 'x-fa fa-check',
            ui: 'alt confirm',
            text: '通过',
            commit: (list, info) => doSubmitTask({ task: info.record.data, comment: "", result: "通过", onSuccess: () => doGetAllTaskList() }),
          }, {
            iconCls: 'x-fa fa-times',
            ui: 'alt decline',
            text: '驳回',
            commit: (list, info) => doSubmitTask({ task: info.record.data, comment: "", result: "驳回", onSuccess: () => doGetAllTaskList() }),
          }]
        }]}
      />
    )
  }

  render() {
    const { showSearchForPhone, loading, selectedTaskType, allTaskList } = this.state
    const selectedTaskList = selectedTaskType === "全部" ? allTaskList : allTaskList && allTaskList.filter(item => item.title === selectedTaskType)
    const panelProps = {
      height: "100%",
      margin: '0 0 0 0',
      padding: '0 0 0 0'
    }
    return (
      <Panel shadow layout="vbox" {...panelProps}>
        <Container layout="fit" flex={0}>
          <AppTitle
            showSearchForPhone={showSearchForPhone}
            onClick={this.handleSearchClick}
            onSearch={this.search}
            allTaskList={allTaskList}
            onSelectType={this.handleSelectType}
            selectedTaskType={selectedTaskType}
          />
        </Container>
        <Container layout="fit" flex={4}>
          {!loading && this.tasks({ selectedTaskList })}
        </Container>
      </Panel>
    )
  }
}

const mapStateToProps = ({ }) => ({})

export default compose(
  connect(mapStateToProps, { doGetAllTaskList, doSubmitTask }),
)(MyTask)
